import React from 'react'
import { withRouter } from 'react-router-dom'
import GLOBAL from '../Global'

const NotFound = () => {
  return <div>{GLOBAL.NOTFOUND.TEXT}</div>
}

export default withRouter(NotFound)
